import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

const THUMB_SIZE = 40;

interface Props {
  url: string | null;
  name: string;
}

export default function ItemThumbnail({ url, name }: Props) {
  return (
    <Box
      sx={{
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        flexShrink: 0,
        borderRadius: '8px',
        overflow: 'hidden',
        bgcolor: theme => theme.palette.lightGrey.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      {url ? (
        <Box
          component="img"
          src={url}
          alt={name}
          loading="lazy"
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <ImageOutlinedIcon fontSize="small" sx={{ color: 'text.disabled' }} />
      )}
    </Box>
  );
}
